import { __extends } from "tslib";
var StylesProviderIsNotReadyError = /** @class */ (function (_super) {
    __extends(StylesProviderIsNotReadyError, _super);
    function StylesProviderIsNotReadyError() {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nStylesProvider is not ready. Styles are not loaded.\nUsually this case should be unreachable.  \nIn case you face it use \"context.ready: boolean\" flag not determine if it possible to set/get params. \n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return StylesProviderIsNotReadyError;
}(Error));
export { StylesProviderIsNotReadyError };
//# sourceMappingURL=StylesProviderIsNotReadyError.js.map